<div class="action-buttons" *ngIf="!isViewMode">
  <dx-select-box
    *ngIf="questions.length === 0"
    class="template-dropdown"
    [items]="templateOptions"
    displayExpr="label"
    valueExpr="this"
    [value]="null"
    [placeholder]="'TRAINING-QUESTIONNAIRE.FORM.APPLY-TEMPLATE' | translate"
    (onValueChanged)="onTemplateChange($event)">
  </dx-select-box>
</div>

<div 
  *ngFor="let question of questions; let i = index" 
  class="question-container"
>
  <dx-form #dxFormRef
    [formData]="question"
    [showColonAfterLabel]="false"
    [readOnly]="isViewMode"
  >
    <dxi-item itemType="group">
      <dxo-col-count-by-screen 
        [xs]="1" 
        [sm]="1" 
        [md]="2" 
        [lg]="5"
      ></dxo-col-count-by-screen>

      @if(question.isPending) {
        <dxi-item [colSpan]="2">
          <dx-select-box
            class="template-dropdown-full"
            [items]="templateOptions"
            displayExpr="label"
            valueExpr="this"
            [value]="null"
            [placeholder]="'TRAINING-QUESTIONNAIRE.FORM.APPLY-TEMPLATE' | translate"
            (onValueChanged)="onRowSelectionChange($event, i)">
          </dx-select-box>
        </dxi-item>
        <dxi-item [colSpan]="2">
        </dxi-item>
      } @else {      
        <dxi-item
          dataField="question"
          editorType="dxTextBox"
          [colSpan]="2"
          [label]="{ visible: false }"
          [editorOptions]="{
            readOnly: isViewMode || question.templateId,
            placeholder: ('TRAINING-QUESTIONNAIRE.FORM.TYPE-YOUR-OWN-QUESTION' | translate)
          }"
        >
          <dxi-validation-rule
            type="required"
            [message]="'VALIDATIONS.QUESTION-TEXT-REQUIRED' | translate"
          ></dxi-validation-rule>
        </dxi-item>
        
        @if(
          question.type === participationTypes.SingleSelect ||
          question.type === participationTypes.MultiSelect
        ) {
          <dxi-item [colSpan]="2">
            <dx-drop-down-box
              [readOnly]="isViewMode"
              valueExpr="value"
              displayExpr="value"
              stylingMode="outlined"
              [placeholder]="'TRAINING-QUESTIONNAIRE.FORM.PREVIEW-OPTIONS' | translate"
              labelMode="floating"
            >
              <div *dxTemplate="let data of 'content'">
                <dx-tree-view
                  [dataSource]="question.options ?? []"
                  keyExpr="value"
                  displayExpr="value"
                  [selectNodesRecursive]="false"
                  [selectByClick]="false"
                  [showCheckBoxesMode]="'none'"
                >
                </dx-tree-view>
              </div>
            </dx-drop-down-box>
          </dxi-item>
        } @else if(question.type === participationTypes.AdditionalPersons) {
          <dxi-item
            dataField="maxAdditionalPersons"
            editorType="dxNumberBox"
            [colSpan]="2"
            [label]="{ visible: false }"
            [editorOptions]="{
              readOnly: isViewMode,
              min: 0,
              placeholder: ('TRAINING-QUESTIONNAIRE.FORM.SET-MAX-PARTICIPANTS-AMOUNT' | translate)
            }"
          >
            <dxi-validation-rule
              type="required"
              [message]="'VALIDATIONS.MAX-ADDITIONAL-PERSONS-REQUIRED' | translate"
            ></dxi-validation-rule>
            <dxi-validation-rule
              type="range"
              [min]="1"
              [message]="'VALIDATIONS.MAX-ADDITIONAL-PERSONS-MIN-1' | translate"
            ></dxi-validation-rule>
          </dxi-item>
        } @else if(question.type === participationTypes.HotelBooking) {
          <dxi-item [colSpan]="2">
            <dx-select-box
              [items]="availableQuestionTypes" 
              displayExpr="label" 
              valueExpr="value" 
              [value]="participationTypes.YesNo"
              [readOnly]="true"
            ></dx-select-box>
            <app-date-selection
              [startDateLabel]="'TRAINING-QUESTIONNAIRE.FORM.EARLIEST-CHECK-IN-DATE' | translate"
              [endDateLabel]="'TRAINING-QUESTIONNAIRE.FORM.LATEST-CHECK-OUT-DATE' | translate"
              [(startDate)]="question.startHotelDate"
              [minStartDate]="today"
              [(endDate)]="question.endHotelDate"
              [preventSameDay]="true"
              [isViewMode]="isViewMode"
              [disabled]="disableDateSelection"
            ></app-date-selection>
          </dxi-item>
        } @else {
          <dxi-item
            dataField="type"
            editorType="dxSelectBox"
            [colSpan]="2"
            [label]="{ visible: false }"
            [editorOptions]="{
              readOnly: isViewMode,
              items: availableQuestionTypes,
              displayExpr: 'label',
              valueExpr: 'value',
              placeholder: ('TRAINING-QUESTIONNAIRE.FORM.SELECT-ANSWERING-OPTION' | translate)
            }"
          >
            <dxi-validation-rule
              type="required"
              [message]="'VALIDATIONS.ANSWER-OPTION-REQUIRED' | translate"
            ></dxi-validation-rule>
          </dxi-item>
        }
      }
      
      <dxi-item [colSpan]="1">
        <div class="actions-container">
          <dx-check-box
            [readOnly]="isViewMode"
            [(value)]="question.isRequired"
            [text]="'TRAINING-QUESTIONNAIRE.FORM.SET-AS-REQUIRED' | translate"
          ></dx-check-box>
          <dx-button
            *ngIf="!isViewMode"
            [hint]="'COMMON.DELETE' | translate"
            type="danger"
            stylingMode="text"
            class="action"
            (onClick)="removeQuestion(i)"
          >
            <i class="fa-solid fa-trash-can action-icon"></i>
          </dx-button>
        </div>
      </dxi-item>
    </dxi-item>
  </dx-form>
</div>

<div class="questions-footer" *ngIf="!isViewMode">
  <dx-button
    [text]="'TRAINING-QUESTIONNAIRE.FORM.ADD-QUESTION' | translate"
    icon="add"
    (onClick)="addQuestion()"
  ></dx-button>
</div>
